import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const newsEventsCarousels = document.querySelectorAll(
    '.carrousel-news .carrousel-news__carousel'
  );

  if (0 < newsEventsCarousels.length) {
    newsEventsCarousels.forEach((newsEventsCarousel) => {
      new Swiper(newsEventsCarousel, {
        slidesPerView: 1,
        spaceBetween: 24,
        navigation: {
          nextEl: '.carrousel-news__next.swiper-button-next',
          prevEl: '.carrousel-news__prev.swiper-button-prev',
        },
        breakpoints: {
          600: {
            slidesPerView: 2,
          },
          900: {
            slidesPerView: 2.75,
          },
        },
      });
    });
  }
});
